var map = {
	"./de-de.json": 26132,
	"./en.json": 82007,
	"./es-mx.json": 42775,
	"./fr-ca.json": 15217,
	"./fr-fr.json": 86762,
	"./ja-jp.json": 41552,
	"./ko-kr.json": 59516,
	"./pt-br.json": 88982,
	"./ru-ru.json": 98264,
	"./th-th.json": 29346,
	"./zh-tw.json": 98781,
	"./zh.json": 47939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66354;